import { render, staticRenderFns } from "./ForgetPass.vue?vue&type=template&id=3509f5e1&scoped=true&"
import script from "./ForgetPass.vue?vue&type=script&lang=js&"
export * from "./ForgetPass.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPass.vue?vue&type=style&index=0&id=3509f5e1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509f5e1",
  null
  
)

component.options.__file = "ForgetPass.vue"
export default component.exports